import { configureStore } from '@reduxjs/toolkit';
import { enableMapSet } from 'immer';
import usersReducer from './slices/usersSlice';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import organizationsReducer from './slices/organizationsSlice';
import toastReducer from './slices/toastSlice';
import limitsReducer from './slices/limitsSlice';

// Enable MapSet support in Immer
enableMapSet();

export const store = configureStore({
  reducer: {
    users: usersReducer,
    auth: authReducer,
    dashboard: dashboardReducer,
    organizations: organizationsReducer,
    toast: toastReducer,
    limits: limitsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['users/toggleUserSelection', 'users/togglePageSelection', 'users/clearSelectedUsers'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.selectedUserIds'],
        // Ignore these paths in the state
        ignoredPaths: ['users.selectedUserIds'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
